import React from 'react';
import { noop } from 'lodash';
import { string, func, shape, arrayOf } from 'prop-types';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { CURRENT_USER } from '../../../propTypes/currentUser';
import { getStartedUrl } from '../../../constants/urls';
import Breadcrumbs from '../../Breadcrumbs';
import CloudinaryResponsiveImage from '../../CloudinaryResponsiveImage';
import { IMAGE_RESOLUTIONS } from './constants';
import './style.scss';

const DiscoverHero = ({
    heroImageUrl,
    titlePrefix,
    descriptionPrefix,
    additionalDescriptionPrefix,
    onMakeYourLogoClick = noop,
    breadcrumbsParams,
}) => (
    <section className="discover-hero hero-section">
        <div className="hero-container">
            <div className="featured-image-wrapper">
                <CloudinaryResponsiveImage
                    image={heroImageUrl}
                    mediaQueryGrid={IMAGE_RESOLUTIONS}
                    alt={translate('logo_maker_perseus.discover_logo_ideas.logo_design_example')}
                />
            </div>
            <div className="hero-content">
                <Breadcrumbs {...breadcrumbsParams} />
                <h1 className="hero-title">
                    <I18n k={titlePrefix} />
                </h1>
                <p className="hero-description">
                    {additionalDescriptionPrefix && (
                        <span>
                            <I18n k={additionalDescriptionPrefix} />
                        </span>
                    )}
                    <span>
                        <I18n k={descriptionPrefix} />
                    </span>
                </p>
                <a
                    onClick={onMakeYourLogoClick}
                    href={getStartedUrl()}
                    rel="nofollow"
                    color="white"
                    className="hero-button"
                >
                    <I18n k="logo_maker_perseus.general.make_your_logo" />
                </a>
            </div>
        </div>
    </section>
);

DiscoverHero.propTypes = {
    heroImageUrl: string,
    titlePrefix: string,
    descriptionPrefix: string,
    additionalDescriptionPrefix: string,
    onMakeYourLogoClick: func,
    breadcrumbsParams: shape({
        list: arrayOf(
            shape({
                name: string,
                url: string,
            })
        ),
        theme: string,
    }),
    currentUser: CURRENT_USER,
};

export default DiscoverHero;
